import axios from "axios";

import { REACT_APP_API_URL } from "../config/config";
import type { RatingCategory, SiteConfig } from "../types";

export type { RatingCategory as RatingType, SiteConfig, Vpn } from "../types";

const api = axios.create({
  baseURL: REACT_APP_API_URL,
});

export const apiVpnStar = {
  getSiteConfig: async (): Promise<SiteConfig> => {
    try {
      const response = await api.get<SiteConfig>("/api/site-config/");
      return response.data;
    } catch (error) {
      console.info("Error fetching site config:", error);
      throw error;
    }
  },

  getRatingTypes: async (): Promise<RatingCategory[]> => {
    try {
      const response = await api.get<RatingCategory[]>("/api/rating_types/");
      const data = [...response.data];

      data.sort((a, b) => a.order - b.order);

      return data;
    } catch (error) {
      console.info("Error fetching rating types:", error);
      throw error;
    }
  },

  getImageUrl: (imagePath?: string): string => {
    if (!imagePath) return "";
    if (/^https?:\/\//i.test(imagePath)) return imagePath;
    const path = imagePath.startsWith("/") ? imagePath : `/${imagePath}`;
    return `${REACT_APP_API_URL}${path}`;
  },
};
